module.exports = __webpack_public_path__ + "static/media/woman-looking-train@2x.72ad8af5-min.85d24117.png";